import { Button, CardMedia, Container, Grid2, Typography } from "@mui/material";
import React from "react";
import useScreenSize from "../../../hooks/useScreenSize";

export interface IDestacadoFotoProps {
    title: string;
    desc: any;
    img: string;
    btnLabel: string;
    btnRedirect: string;
}

export const DestacadoFoto2 = ({
    title,
    desc,
    img,
    btnLabel,
    btnRedirect,
}: IDestacadoFotoProps
) => {
    const getResponsiveMaxWidth = (screenSize: number): string => {
        if (screenSize > 1440) return "1200px";
        if (screenSize > 968) return "86%";
        return "100%";
    };

    const isMobile = (screenSize: number): boolean => screenSize <= 800;

    return(
        <Container 
            sx={{ 
            backgroundColor: "#E9EBFF", 
            borderRadius: "3rem", 
            maxWidth:  getResponsiveMaxWidth(useScreenSize()),
            margin: "0 auto" , 
            padding: isMobile(useScreenSize()) ? "0":"0 4rem",
            marginBottom: "2rem"
            }} 
        >
            <Grid2 container sx={{padding: isMobile(useScreenSize()) ? 6 : 2 }} marginTop="2rem 4rem">
                <Grid2  size={{xs: 12, sm:12, md:6, lg:6 }} sx={{padding: isMobile(useScreenSize()) ? 0 : 6}}>
                    <Typography variant="h4" component="h2" align="left" fontWeight="bold" sx={{marginTop: isMobile(useScreenSize()) ? 0 : 2}}>
                        {title}
                    </Typography>
                    <Typography variant="body1" align="justify" marginTop={4} >
                        {desc}
                    </Typography>
                </Grid2>
                <Grid2 
                    size={{ xs: 12, sm:12, md:6, lg:6  }} 
                    sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        padding: isMobile(useScreenSize()) ? 0 : 4
                    }}
                >
                    <CardMedia 
                        component="img"
                        sx={{ 
                            aspectRatio: '16/9', 
                            marginTop: "2rem", 
                            marginBottom: "2rem", 
                            borderRadius: "16px"
                        }}
                        image={img}
                        title={title}
                    />
                    <Button 
                        variant="contained"  
                        sx={{ 
                            bgcolor: "#ee2b7b", 
                            marginTop: "1rem", 
                            borderRadius: "26px", 
                            minWidth: "8rem", 
                            paddingLeft: "2rem", 
                            paddingRight: "2rem" 
                        }}
                        onClick={() => window.location.href = btnRedirect}
                    >
                        {btnLabel}
                    </Button>
                </Grid2>
            </Grid2>
        </Container>
    );   
}
